import React from 'react';
import {Elements} from 'react-stripe-elements';

import InjectedCheckoutForm from './CheckoutForm';

const CheckoutForm = ({ client_secret, user, loading, onSuccess }) => (
  <Elements>
    <InjectedCheckoutForm
      loading={loading}
      onSuccess={onSuccess}
      user={user}
      client_secret={client_secret}
    />
  </Elements>
)

export default CheckoutForm



// WEBPACK FOOTER //
// ./src/modules/booking/StoreCheckout.js